const Footer = () => {
  return (
    <footer className="w-full bg-[#162447] text-gray-300 py-6 text-center shadow-md">
      <p className="text-sm">&copy; {new Date().getFullYear()} Rodney Cunanan. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
